import { useRouter } from 'next/router'
import { Notice } from '@pretamanger/component-library'
import {
  translate,
  hasTranslationFor
} from '#src/common/components/translation/'
import { NoticeWrapper } from '#src/products/product-details-page/components/nutritionals/styles'

const nutritionalDisclaimerKey = 'product.nutritionals.disclaimer'

const NutritionalDisclaimer = () => {
  const { locale } = useRouter()
  if (!hasTranslationFor(nutritionalDisclaimerKey, locale)) {
    return null
  }
  return (
    <NoticeWrapper>
      <Notice
        title={translate(nutritionalDisclaimerKey, locale)?.value}
        variant='base'
      />
    </NoticeWrapper>
  )
}

export default NutritionalDisclaimer
